/**
 * Unified Form Submission Service
 * Submits form data to a Google Sheets backend via Apps Script
 *
 * Supports: contact forms, newsletter subscriptions, career applications
 */

const FORM_URL = import.meta.env.VITE_CONTACT_FORM_URL

/**
 * Submit form data to the backend
 * @param {Object} params
 * @param {string} params.type - Form type: 'contact', 'newsletter', 'career', 'partner'
 * @param {Object} params.data - Form field data
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export async function submitForm({ type, data }) {
  if (!data.email) {
    return { success: false, error: 'Please enter a valid email address.' }
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(data.email)) {
    return { success: false, error: 'Please enter a valid email address.' }
  }

  if (!FORM_URL) {
    console.warn(`Form submission (${type}):`, data)
    if (import.meta.env.DEV) {
      console.log('Development mode: Simulating successful submission')
      return { success: true }
    }
    return {
      success: false,
      error: 'Form submission is temporarily unavailable. Please try again later.',
    }
  }

  try {
    const response = await fetch(FORM_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({
        formType: type,
        ...data,
        url: window.location.href,
        timestamp: new Date().toISOString(),
      }),
    })

    const result = await response.json()
    if (result.success) {
      return { success: true }
    }

    return { success: false, error: 'Submission failed. Please try again.' }
  } catch (error) {
    console.error('Form submission error:', error)
    return { success: false, error: 'Submission failed. Please try again.' }
  }
}
